import { socketUpdateWatchHistory } from "@/socket";
import actions from "@/store/actions";
import utils from "@/utils";
import api from "@/api";

export const fetchHistory = (user) => {
  return async (dispatch) => {
    if (utils.getCookie("login_state") || user?.email) {
      const res = await api.getUserWatchHistory(user?._id);
      if (res.status === 200) {
        dispatch(actions.historyActions.fetchwatchhistory(res.data?.result));
        return;
      }
    }
    dispatch(actions.historyActions.fetchwatchhistory([]));
  };
};

export const updateWatchHistory = (history, socket, userId) => {
  return async (dispatch) => {
    // console.log("Socket Called history", history);
    if (history.length) {
      const historyData = history.map((item) => {
        const splitId = item.id?.split("_");
        let courseId;
        let videoId;
        if (splitId.length === 2) {
          courseId = item.id ? item.id.split("_")[0] : undefined;
          videoId = item.id ? item.id.split("_")[1] : undefined;
        } else {
          videoId = item.id;
        }
        return {
          courseId: courseId ?? null,
          videoId,
          currSecs: item.currsecs,
          lastPlayStatus: item.lastplaystatus,
          initiate: new Date(item.initiate).toISOString(),
        };
      });

      socketUpdateWatchHistory(
        {
          userId: userId,
          history: historyData,
        },
        socket
      );
    }

    dispatch(actions.historyActions.updatehistory(history));
    return;
  };
};
